module.exports = __webpack_public_path__ + "static/media/importICloud1.dabed0a0.png";